import React from "react";
import { Table } from "react-bootstrap";
import { MaterialSummary, calculateMaterialsUsed } from "./stolarz_form_summary";
import { DBMaterialType } from "../database_types";
import { getMaterial } from "./database_helpers";
import { FormData, ProductData } from "./stolarz_form_types";
import { FieldErrors, } from "react-hook-form";
import { StringToJSX } from "./StringToJSX";

export function generateEmail(formData: FormData, oldFormData: FormData | undefined, errors: FieldErrors<FormData>, props: { materialsDB: DBMaterialType[]; edgesDB: DBMaterialType[]; }): React.JSX.Element {
    if (!formData) { return <></> }
    if (!formData.products) { return <></> }
    const [isUserDataChanged, addedProducts, deletedProducts, changedProducts, unChangedProducts] = compareFormData(oldFormData, formData)
    return <div>
        <p>
            Dzień dobry,<br />

            uprzejmie proszę o potwierdzenie złożenia zamówienie formatek.
        </p>
        <p>
            {formData.summary}
        </p>
        {oldFormData && <h2>Lista różnic</h2>}
        {isUserDataChanged && <div className="text-info">Dane zmawiającego uległy zmianie!</div>}
        {unChangedProducts.length !== 0 && <div className="text-info">Bez zmian: <strong>{unChangedProducts.map((product) => product.productName + " ")}</strong> </div>}
        {addedProducts.length !== 0 && <div className="text-success">Dodano: <strong>{addedProducts.map((product) => product.productName + " ")}</strong> </div>}
        {deletedProducts.length !== 0 && <div className="text-danger">Usunięto: <strong>{deletedProducts.map((product) => product.productName + " ")}</strong> </div>}
        {changedProducts.length !== 0 && <div className="text-info">Zmieniono: <strong>{changedProducts.map((product) => product.old.productName + " ")}</strong> </div>}

        <h2>Lista formatek</h2>

        {formData.products.map((field: ProductData, productIndex) => <>
            <p><strong>{formData.products[productIndex].productName} (x {formData.products[productIndex].amount})</strong></p>
            {perSheetTable(formData.products[productIndex], props.materialsDB)}
        </>)}
        <h2>Lista materiałów </h2>
        {formData.products.map((field, productIndex) => <>
            <p><strong>{formData.products[productIndex].productName} (x {formData.products[productIndex].amount})</strong></p>
            {perMaterialTableNoWatch(formData.products[productIndex], errors?.products?.[productIndex], props)}
        </>
        )}
        <p>Załączam plik wygenerowany przez portal formatki.stolarz.net.pl</p>
        <p>
            Pozdrawiam,<br />
            {<strong>{formData.name} <br /></strong>}
            {formData.nip && <>Nip: {formData.nip} <br /></>}
            {formData.email && <>{formData.email} <br /></>}
            {formData.address && <>{formData.address}, </>}
            {formData.postalCode && <>{formData.postalCode} </>}
            {formData.city && <>{formData.city}<br /></>}
        </p>
        {/* <div style={{whiteSpace: "pre-wrap"}}>

            ---proszę nie edytuj poniższej zawartości/please do not edit below contents---<br></br>
            {jsonToOptimik3(watch())}
        </div> */}
        {/* <pre style={{ whiteSpace: "pre-wrap" }}>
            ---proszę nie edytuj poniższej zawartości/please do not edit below contents---
            <br />
            <br />
            {jsonToOptimik3(watch())}
        </pre> */}
    </div>;
}

export function compareFormData(oldForm: FormData | undefined, newForm: FormData): [boolean, ProductData[], ProductData[], { old: ProductData; new: ProductData; }[], ProductData[]] {
    if (oldForm == undefined) {
        return [false, [], [], [], []]
    }
    const isUserDataChanged =
        oldForm.name !== newForm.name ||
        oldForm.email !== newForm.email ||
        oldForm.address !== newForm.address ||
        oldForm.nip !== newForm.nip ||
        oldForm.city !== newForm.city ||
        oldForm.postalCode !== newForm.postalCode;

    const addedProducts = newForm.products.filter((newProduct) => !oldForm.products.some((oldProduct) => oldProduct.productName === newProduct.productName))
    const deletedProducts = oldForm.products.filter((oldProduct) => newForm.products.every((newProduct) => oldProduct.productName !== newProduct.productName))
    let changedProducts: { old: ProductData; new: ProductData; }[] = [];
    let unChangedProducts: ProductData[] = [];
    for (const oldProduct of oldForm.products) {
        const matchedByName = newForm.products.filter((newProduct) => oldProduct.productName === newProduct.productName);
        // todo hiden bug: names can be the same...
        if (JSON.stringify(matchedByName[0]) !== JSON.stringify(oldProduct)) {
            changedProducts.push({ 'old': oldProduct, 'new': matchedByName[0] })
        } else{
            unChangedProducts.push(oldProduct)
        }
    }
    console.log(changedProducts)

    return [isUserDataChanged, addedProducts, deletedProducts, changedProducts, unChangedProducts];
}

// impossible to implement based on product name comparison
// function compareProducts(oldProduct: ProductData, newProduct: ProductData) {
//     return <>
//     {oldProduct.amount !== newProduct.amount }
//     </>
// }

export function generatePreviewNoWatch(products: ProductData[], props: { materialsDB: DBMaterialType[]; edgesDB: DBMaterialType[]; }): React.JSX.Element {
    if (products === undefined) {
        return <></>
    }
    return <div className="alert alert-light">
        {/* <h3>Dane zamawiającego</h3>
        <p>
            {<strong>{formData.name} <br /></strong>}
            {formData.nip && <>Nip: {formData.nip} <br /></>}
            {formData.email && <>{formData.email} <br /></>}
            {formData.address && <>{formData.address}, </>}
            {formData.postalCode && <>{formData.postalCode} </>}
            {formData.city && <>{formData.city}<br /></>}
        </p> 
        <p>
            {formData.summary}
        </p> */}
        <h2>Lista formatek</h2>
        {products.map((field: ProductData, productIndex) => <>
            <p><strong>{field.productName} (x {field.amount})</strong>, poniżej przeliczono dla 1 sztuki</p>
            {perSheetTable(field, props.materialsDB)}
        </>)}
        <h2>Lista materiałów </h2>
        {products.map((field: ProductData, productIndex) => <>
            <p><strong>{field.productName} (x {field.amount})</strong>, poniżej przeliczono dla 1 sztuki</p>
            {perMaterialTableNoWatch(field, null, props)}
        </>
        )}
    </div>;
}

// export function generateWarnings(product: ProductData) {
//     //todo zod complex validation
//     return <div className="alert alert-warnings">

//     </div>
// }

// function generateWarningSingle(sheet: SheetData) {
//     let results = [];
//     const tooThin = checkSheetTooThin(sheet);
//     results.push(tooThin)
//     return results;
// }

// function checkSheetTooThin(sheet: SheetData) {
//     if (sheet.length > sheet.width) { // we are interested in shorter edge
//         if (sheet.edgeDown.edgeCode !== "" || sheet.edgeUp.edgeCode !== "") {
//             if (sheet.width < 85) {
//                 return "Formatka jest zbyt płytka aby okleić ten bok!"
//             }
//         }
//     } else {
//         if (sheet.edgeLeft.edgeCode !== "" || sheet.edgeRight.edgeCode !== "") {
//             if (sheet.length < 85) {
//                 return "Formatka jest zbyt płytka!"
//             }
//         }
//     }
// }

function perSheetTable(product: ProductData, materials: DBMaterialType[]) {
    return <Table striped bordered hover size="sm">
        <thead>
            <tr>
                <th>Nazwa</th>
                <th>Komentarz</th>
                <th>Ilość</th>
                <th>Dł</th>
                <th>Sz</th>
                <th>Materiał</th>
                <th>Usłojenie</th>
                <th>Grubość</th>
                <th>Krawędż dł 1</th>
                <th>Krawędż dł 2</th>
                <th>Krawędż sz 1</th>
                <th>Krawędż sz 2</th>
            </tr>
        </thead>
        <tbody>
            {product.sheets.map(sheet => {
                const n = product.amount
                const material = getMaterial(materials, sheet.materialCode);
                return <tr>
                    <td>{sheet.itemName || "-"}</td>
                    <td>{sheet.itemComment || "-"}</td>
                    <td>{sheet.amount * n}</td>
                    <td>{sheet.length}</td>
                    <td>{sheet.width}</td>
                    <td>{material?.name}</td>
                    <td>{sheet.useGrain ? "tak" : "nie"}</td>
                    <td>{material?.thickness}</td>
                    <td>{sheet.edgeDown.edgeCode || "-"}</td>
                    <td>{sheet.edgeUp.edgeCode || "-"}</td>
                    <td>{sheet.edgeRight.edgeCode || "-"}</td>
                    <td>{sheet.edgeLeft.edgeCode || "-"}</td>
                </tr>
            })}
        </tbody>
    </Table>;
}

function perMaterialTableNoWatch(product: ProductData, errors: FieldErrors<ProductData> | null | any | undefined, props: { materialsDB: DBMaterialType[]; edgesDB: DBMaterialType[]; }) {
    // todo fix typing of error
    if (product?.sheets === undefined) {
        return <></>
    }
    const showErrorColumn: boolean = (errors && errors.sheets)
    return <Table striped bordered hover size="sm">
        <thead>
            <tr>
                <th>Materiał</th>
                <th>Ilość formatek</th>
                <th>Grubość</th>
                <th>Powierzchnia</th>
                <th>Krawędzie</th>
                {showErrorColumn ? <th className="text-danger">Błędy</th> : <></>}
            </tr>
        </thead>
        <tbody>
            <>
                {Array.from(calculateMaterialsUsed(product.sheets, props.materialsDB).values()).map((value: MaterialSummary, index: number) => {
                    const n = product.amount;
                    const edges = Array.from(value.edges.values());
                    const sheetErrors = errors?.sheets?.[index]
                    let edgesSummary: React.JSX.Element[] = edges.map(edge => <li>{edge.edgeMaterial}: {(edge.runningMeter * n).toFixed(2)} m</li>);
                    return <tr>
                        <td>{value.material?.name} </td>
                        <td>{value.numberOfInstances * n}</td>
                        <td>#{value.material?.thickness}mm</td>
                        <td>{(value.m2 * n).toFixed(2)}㎡</td>
                        <td>
                            {edges.length ? <ul key={`product-${product}`} style={{ margin: "0" }}>{edgesSummary}</ul> : "brak"}
                        </td>
                        {showErrorColumn && sheetErrors ? <td className="text-danger">
                            {sheetErrors?.message}
                            {/* {sheetErrors?.width?.message} {sheetErrors?.length?.message} */}
                            <StringToJSX domString={sheetErrors?.width?.message?.toString() || ""} />
                            <StringToJSX domString={sheetErrors?.length?.message?.toString() || ""} />
                            {sheetErrors?.itemName?.message}
                            {sheetErrors?.itemComment?.message}
                            {sheetErrors?.edgeDown?.message}
                            {sheetErrors?.edgeLeft?.message}
                            {sheetErrors?.edgeRight?.message}
                            {sheetErrors?.edgeUp?.message}
                            {sheetErrors?.edgeDown?.edgeCode?.message}
                            {sheetErrors?.edgeLeft?.edgeCode?.message}
                            {sheetErrors?.edgeRight?.edgeCode?.message}
                            {sheetErrors?.edgeUp?.edgeCode?.message}
                        </td> : <></>}
                    </tr>;
                })}</>
        </tbody>
    </Table>;
}
